/**
 * @file StationFilterTabs.tsx
 * @description Station routing filter tabs allowing kitchen stations to isolate their tickets with TableGreet brand styling.
 */

import React from 'react';
import type { KitchenStation } from '../../../types/order.types';

interface StationFilterTabsProps {
  currentStation: KitchenStation;
  onSelectStation: (station: KitchenStation) => void;
  stationCounts: Record<string, number>;
}

const STATIONS: { id: KitchenStation; label: string }[] = [
  { id: 'all', label: 'All Stations' },
  { id: 'hot', label: 'Hot Kitchen' },
  { id: 'grill', label: 'Grill' },
  { id: 'cold', label: 'Cold / Salad' },
  { id: 'dessert', label: 'Dessert' },
  { id: 'drinks', label: 'Bar & Drinks' },
];

export const StationFilterTabs: React.FC<StationFilterTabsProps> = ({
  currentStation,
  onSelectStation,
  stationCounts,
}) => {
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-none">
      {STATIONS.map(st => {
        const isSelected = currentStation === st.id;
        const count = stationCounts[st.id] || 0;

        return (
          <button
            key={st.id}
            type="button"
            onClick={() => onSelectStation(st.id)}
            className={`px-3.5 py-2 min-h-[40px] rounded-xl text-xs font-bold whitespace-nowrap flex items-center gap-1.5 transition-all active:scale-95 cursor-pointer ${
              isSelected
                ? 'bg-[#ff4f00] text-white shadow-lg shadow-[#ff4f00]/25 font-black'
                : 'bg-[#181818] text-zinc-400 border border-white/10 hover:text-white hover:bg-white/5'
            }`}
          >
            <span>{st.label}</span>
            {count > 0 && (
              <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-mono font-bold ${
                isSelected ? 'bg-black/30 text-white' : 'bg-white/10 text-zinc-300'
              }`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
